import { createSlice } from '@reduxjs/toolkit';
import { athkarElnom} from './allAthkar';
import { numDecreaseAct, prograssNum, showInfoAct } from './actions';



const athkarElnomSlice = createSlice({
  name: 'athkarElnom',
  initialState: athkarElnom,
  reducers: {
    showInfoN: showInfoAct,
    numDecreaseN: numDecreaseAct,
    prograssNumN:prograssNum
  },
});

export const { showInfoN, numDecreaseN,prograssNumN } = athkarElnomSlice.actions;
export default athkarElnomSlice.reducer;